// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getBrands } from "@insite/client-framework/Services/BrandService";
import {
    chain,
    DispatchCompleteLoadBrands,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Pages/Brands/Handlers/LoadAllBrands";
import { BrandModel } from "@insite/client-framework/Types/ApiModels";

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    const pages: BrandModel[][] = [];
    const pageSize = props.parameter.pageSize || 500;
    const getPage = async (page: number) => {
        const parameter = {
            ...props.parameter,
            pageSize,
            page,
        };
        const apiResult = await getBrands(parameter);
        pages[page] = apiResult.brands!;
        // XNG-Changes
        (props as any).industries = JSON.parse(apiResult.properties?.industriesList || `[]`);
        return apiResult;
    };

    const { pagination } = await getPage(1);
    const promises = [];
    for (let x = 2; (x - 1) * pageSize < pagination!.totalItemCount; x++) {
        promises.push(getPage(x));
    }
    await Promise.all(promises);

    let collection: BrandModel[] = [];
    for (const page of pages) {
        if (!page) {
            continue;
        }
        collection = collection.concat(page);
    }

    props.result = collection;
};

export const XngDispatchCompleteLoadBrands: typeof DispatchCompleteLoadBrands = props => {
    props.dispatch({
        type: "xBrands/CompleteLoadBrandsIndustries" as any,
        collection: (props as any).industries,
    });
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
addToChainAfter(chain, DispatchCompleteLoadBrands, XngDispatchCompleteLoadBrands);
